import { CommonModule, DatePipe, DecimalPipe } from '@angular/common';
import { NgModule } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { NgApexchartsModule } from 'ng-apexcharts';
import { PipeModule } from 'src/app/extensions/pipes/pipe.module';
import { ComponentsModule } from 'src/app/extensions/components/components.module';
import { AppDashboardContainerComponent } from './app-dashboard-container/app-dashboard-container.component';
import { AppDashboardRoutingModule } from './app-dashboard-routing.module';

@NgModule({
  imports: [
    AppDashboardRoutingModule,
    TranslateModule.forChild(),
    CommonModule,
    NgApexchartsModule,
    PipeModule,
    ComponentsModule,
  ],
  declarations: [AppDashboardContainerComponent],
  providers: [DatePipe, DecimalPipe],
})
export class AppDashboardModule {}
